function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _classPrivateFieldGet(receiver, privateMap) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return privateMap.get(receiver).value;
}

function _classPrivateFieldSet(receiver, privateMap, value) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to set private field on non-instance");
  }

  var descriptor = privateMap.get(receiver);

  if (!descriptor.writable) {
    throw new TypeError("attempted to set read only private field");
  }

  descriptor.value = value;
  return value;
}

var string = function string(value) {
  return typeof value === "string";
};

var first = function first(str, value) {
  return value.startsWith(str);
};

var last = function last(str, value) {
  return value.endsWith(str);
};

var pattern = function pattern(re, value) {
  return new RegExp(re, "i").test(value);
};

var email = function email(value) // Ipv4 regular RFC 3986
{
  var expresion = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\S[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/i;
  return expresion.test(value.trim());
};

var ipv4 = function ipv4(value) {
  return (// Ipv4 regular RFC 3986
    pattern("^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$", value)
  );
};

var ipv6 = function ipv6(value) {
  return pattern("^(?:(?:(?:[0-9A-Fa-f]{0,4}:){7}[0-9A-Fa-f]{0,4})|(?:(?:[0-9A-Fa-f]{0,4}:){6}:[0-9A-Fa-f]{0,4})|(?:(?:[0-9A-Fa-f]{0,4}:){5}:(?:[0-9A-Fa-f]{0,4}:)?[0-9A-Fa-f]{0,4})|(?:(?:[0-9A-Fa-f]{0,4}:){4}:(?:[0-9A-Fa-f]{0,4}:){0,2}[0-9A-Fa-f]{0,4})|(?:(?:[0-9A-Fa-f]{0,4}:){3}:(?:[0-9A-Fa-f]{0,4}:){0,3}[0-9A-Fa-f]{0,4})|(?:(?:[0-9A-Fa-f]{0,4}:){2}:(?:[0-9A-Fa-f]{0,4}:){0,4}[0-9A-Fa-f]{0,4})|(?:(?:[0-9A-Fa-f]{0,4}:){6}(?:(?:(?:25[0-5])|(?:2[0-4]\\d)|(?:1\\d{2})|(?:\\d{1,2}))\\.){3}(?:(?:25[0-5])|(?:2[0-4]\\d)|(?:1\\d{2})|(?:\\d{1,2})))|(?:(?:[0-9A-Fa-f]{0,4}:){0,5}:(?:(?:(?:25[0-5])|(?:2[0-4]\\d)|(?:1\\d{2})|(?:\\d{1,2}))\\.){3}(?:(?:25[0-5])|(?:2[0-4]\\d)|(?:1\\d{2})|(?:\\d{1,2})))|(?:::(?:[0-9A-Fa-f]{0,4}:){0,5}(?:(?:(?:25[0-5])|(?:2[0-4]\\d)|(?:1\\d{2})|(?:\\d{1,2}))\\.){3}(?:(?:25[0-5])|(?:2[0-4]\\d)|(?:1\\d{2})|(?:\\d{1,2})))|(?:[0-9A-Fa-f]{0,4}::(?:[0-9A-Fa-f]{0,4}:){0,5}[0-9A-Fa-f]{0,4})|(?:::(?:[0-9A-Fa-f]{0,4}:){0,6}[0-9A-Fa-f]{0,4})|(?:(?:[0-9A-Fa-f]{0,4}:){1,7}:))$", value);
};

var ip = function ip(value) {
  return ipv4(value) || ipv6(value);
};

var url = function url(value) {
  return (//
    // Regular Expression for URL validation
    //
    // Author: Diego Perini
    // Created: 2010/12/05
    // Updated: 2018/09/12
    // License: MIT
    // https://gist.github.com/dperini/729294
    new RegExp("^" + // protocol identifier (optional)
    // short syntax // still required
    "(?:(?:(?:https?|ftp):)\\/\\/)" + // user:pass BasicAuth (optional)
    "(?:\\S+(?::\\S*)?@)?" + "(?:" + // IP address exclusion
    // private & local networks
    "(?!(?:10|127)(?:\\.\\d{1,3}){3})" + "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" + "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" + // IP address dotted notation octets
    // excludes loopback network 0.0.0.0
    // excludes reserved space >= 224.0.0.0
    // excludes network & broacast addresses
    // (first & last IP address of each class)
    "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" + "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" + "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" + "|" + // host & domain names, may end with dot
    // can be replaced by a shortest alternative
    // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
    "(?:" + "(?:" + "[a-z0-9\\u00a1-\\uffff]" + "[a-z0-9\\u00a1-\\uffff_-]{0,62}" + ")?" + "[a-z0-9\\u00a1-\\uffff]\\." + ")+" + // TLD identifier name, may end with dot
    "(?:[a-z\\u00a1-\\uffff]{2,})" + ")" + // port number (optional)
    "(?::\\d{2,5})?" + // resource path (optional)
    "(?:[/?#]\\S*)?" + "$", "i").test(value)
  );
};

var alpha = function alpha(value) {
  return pattern("^[a-zA-Z]+$", value);
};

var alphaNum = function alphaNum(value) {
  return pattern("^[a-zA-Z0-9]+$", value);
};

var num = function num(value) {
  return pattern(/^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/, value);
};

var bool = function bool(value) {
  return pattern("^((t|T)(r|R)(u|U)(e|E)|(f|F)(a|A)(l|L)(s|S)(e|E))$", value);
};

var domain = function domain(value) {
  return pattern(/^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/i, value);
};

var host = function host(value) {
  return domain(value) || ipv4(value) || ipv6(value);
};

var string$1 =
/*#__PURE__*/
Object.freeze({
  string: string,
  first: first,
  last: last,
  pattern: pattern,
  email: email,
  ipv4: ipv4,
  ipv6: ipv6,
  ip: ip,
  url: url,
  alpha: alpha,
  alphaNum: alphaNum,
  num: num,
  bool: bool,
  domain: domain,
  host: host
}); // TODO change eval with other method

var run = eval;

var isObjectsEquals = function isObjectsEquals(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

var isEmpty = function isEmpty(obj) {
  return isObjectsEquals(obj, {});
};

var isObject = function isObject(value) {
  return _typeof(value) === "object";
};

var isArray = function isArray(value) {
  return value instanceof Array;
};

var execute = function execute(value) {
  return run(value.join(" "));
};

var isOptionalSuccess = function isOptionalSuccess(value, type) {
  return value === undefined || value === null || value === "" && type === "string" || isObjectsEquals(value, []) && type === "array" || isEmpty(value) && type === "object";
};

var getValue = function getValue(name, values) {
  var names = name.split(".");
  var value = values[names[0]];

  for (var i = 1; i < names.length; i += 1) {
    value = value[names[i]];
  }

  return value;
};

var rulesWrapper = function rulesWrapper(rules) {
  return function (Context) {
    var Field = Context;
    Object.entries(rules).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          name = _ref2[0],
          rule = _ref2[1];

      Field.prototype[name] = function () {
        var _this$_clone = this._clone(),
            _this$_clone2 = _slicedToArray(_this$_clone, 2),
            allRules = _this$_clone2[0],
            not = _this$_clone2[1];

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var ruleObj = {
          rule: rule,
          name: name,
          not: not,
          args: args.slice(0, rule.length - 1),
          options: _objectSpread({
            message: name
          }, args[rule.length - 1])
        };
        return new Context(name === "required" ? [ruleObj].concat(_toConsumableArray(allRules)) : [].concat(_toConsumableArray(allRules), [ruleObj]));
      };
    });
    return Field;
  };
};

var isCrossArg = function isCrossArg(value) {
  return isArray(value) && value[0][0] === "#";
};

var resolveArgs = function resolveArgs(args, values) {
  var newArgs = [];
  args.forEach(function (arg) {
    if (isCrossArg(arg)) {
      var value = getValue(arg[0].slice(1), values);
      newArgs = [].concat(_toConsumableArray(newArgs), [arg.length > 1 ? arg[1](value) : value]);
    } else {
      newArgs = [].concat(_toConsumableArray(newArgs), [arg]);
    }
  });
  return newArgs;
};

var hasFalse = function hasFalse(obj) {
  var values = Object.values(obj);

  for (var i = 0; i < values.length; i += 1) {
    if (values[i] === false || _typeof(values[i]) === "object" && hasFalse(values[i])) return true;
  }

  return false;
};

var none = function none(value) {
  return value === "" || value === null || value === undefined || isEmpty(value) === true || isObjectsEquals(value, []);
};

var required = function required(value) {
  return value !== "" && value !== null && value !== undefined && isEmpty(value) !== true && (value instanceof Array ? value.length !== 0 : true);
};

var custom = function custom(fun, value) {
  return fun(value);
};

var equals = function equals(equalsValue, value) {
  return _typeof(value) === "object" && _typeof(equalsValue) === "object" ? isObjectsEquals(value, equalsValue) : // eslint-disable-next-line
  value == equalsValue;
};

var empty = function empty(value) {
  return value === "" || isObjectsEquals(value, []) || isEmpty(value);
};

var exact = function exact(compair, value) {
  return compair === value;
};

var oneOf = function oneOf(set, value) {
  var data = Object.entries(set).map(function (element) {
    return element[1];
  });

  for (var i = 0; i < data.length; i += 1) {
    if (equals(data[i], value)) {
      return true;
    }
  }

  return false;
};

var exactOneOf = function exactOneOf(set, value) {
  var data = Object.entries(set).map(function (element) {
    return element[1];
  });

  for (var i = 0; i < data.length; i += 1) {
    if (exact(data[i], value)) {
      return true;
    }
  }

  return false;
};

var generic =
/*#__PURE__*/
Object.freeze({
  none: none,
  required: required,
  custom: custom,
  equals: equals,
  empty: empty,
  exact: exact,
  oneOf: oneOf,
  exactOneOf: exactOneOf
});

var array = function array(v) {
  return v instanceof Array;
};

var allEquals = function allEquals(value, arr) {
  for (var i = 0; i < arr.length; i += 1) {
    if (!equals(value, arr[i])) {
      return false;
    }
  }

  return true;
};

var allExact = function allExact(value, arr) {
  for (var i = 0; i < arr.length; i += 1) {
    if (!exact(value, arr[i])) {
      return false;
    }
  }

  return true;
};

var array$1 =
/*#__PURE__*/
Object.freeze({
  array: array,
  allEquals: allEquals,
  allExact: allExact
});

var lengthEquals = function lengthEquals(n, _ref) {
  var length = _ref.length;
  return length === n;
};

var lengthBetween = function lengthBetween(min, max, _ref2) {
  var length = _ref2.length;
  return length > min && length < max;
};

var lengthBetweenOrEquals = function lengthBetweenOrEquals(min, max, _ref3) {
  var length = _ref3.length;
  return length >= min && length <= max;
};

var lengthLess = function lengthLess(n, _ref4) {
  var length = _ref4.length;
  return length < n;
};

var lengthLessOrEquals = function lengthLessOrEquals(n, _ref5) {
  var length = _ref5.length;
  return length <= n;
};

var max = function max(n, _ref6) {
  var length = _ref6.length;
  return lengthLessOrEquals(n, {
    length: length
  });
};

var lengthGreater = function lengthGreater(n, _ref7) {
  var length = _ref7.length;
  return length > n;
};

var lengthGreaterOrEquals = function lengthGreaterOrEquals(n, _ref8) {
  var length = _ref8.length;
  return length >= n;
};

var min = function min(n, _ref9) {
  var length = _ref9.length;
  return lengthGreaterOrEquals(n, {
    length: length
  });
};

var iterator =
/*#__PURE__*/
Object.freeze({
  lengthEquals: lengthEquals,
  lengthBetween: lengthBetween,
  lengthBetweenOrEquals: lengthBetweenOrEquals,
  lengthLess: lengthLess,
  lengthLessOrEquals: lengthLessOrEquals,
  max: max,
  lengthGreater: lengthGreater,
  lengthGreaterOrEquals: lengthGreaterOrEquals,
  min: min
});

var number = function number(value) {
  return typeof value === "number";
};

var between = function between(min, max, value) {
  return value > min && value < max;
};

var betweenOrEquals = function betweenOrEquals(min, max, value) {
  return value >= min && value <= max;
};

var less = function less(n, min) {
  return n < min;
};

var lessOrEquals = function lessOrEquals(n, min) {
  return n <= min;
};

var greater = function greater(n, max) {
  return n > max;
};

var greaterOrEquals = function greaterOrEquals(n, max) {
  return n >= max;
};

var positive = function positive(n) {
  return n >= 0;
};

var negative = function negative(n) {
  return n < 0;
};

var number$1 =
/*#__PURE__*/
Object.freeze({
  number: number,
  between: between,
  betweenOrEquals: betweenOrEquals,
  less: less,
  lessOrEquals: lessOrEquals,
  greater: greater,
  greaterOrEquals: greaterOrEquals,
  positive: positive,
  negative: negative
});

var boolean = function boolean(value) {
  return typeof value === "boolean";
};

var falsy = function falsy(value) {
  return value === false;
};

var truthy = function truthy(value) {
  return value === true;
};

var boolean$1 =
/*#__PURE__*/
Object.freeze({
  boolean: boolean,
  falsy: falsy,
  truthy: truthy
});

var object = function object(value) {
  return _typeof(value) === "object" && !(value instanceof Array);
};

var hasKey = function hasKey(key, obj) {
  return key in obj;
};

var hasValue = function hasValue(value, obj) {
  var values = Object.values(obj);

  for (var i = 0; i < values.length; i += 1) {
    if (values[i] === value) {
      return true;
    }
  }

  return false;
};

var object$1 =
/*#__PURE__*/
Object.freeze({
  object: object,
  hasKey: hasKey,
  hasValue: hasValue
});

var allRules = _objectSpread({}, string$1, array$1, iterator, number$1, generic, object$1, boolean$1);

var isFail = function isFail(isRuleSuccess, constraint, strict, values) {
  return strict ? constraint && constraint.validate(values) !== isRuleSuccess : constraint && constraint.validate(values) && !isRuleSuccess;
};

var messageTemplate = function messageTemplate(message, value, field) {
  return message.replace("%{value}", value).replace("%{field}", field).trim();
};

var Field =
/*#__PURE__*/
function () {
  function Field() {
    var _rules2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var _not2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, Field);

    _rules.set(this, {
      writable: true,
      value: null
    });

    _not.set(this, {
      writable: true,
      value: null
    });

    _classPrivateFieldSet(this, _rules, _rules2);

    _classPrivateFieldSet(this, _not, _not2);
  }

  _createClass(Field, [{
    key: "_clone",
    value: function _clone() {
      return [_classPrivateFieldGet(this, _rules), _classPrivateFieldGet(this, _not)];
    }
  }, {
    key: "any",
    value: function any() {
      return this;
    }
  }, {
    key: "validate",
    value: function validate(value) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$verbose = _ref.verbose,
          verbose = _ref$verbose === void 0 ? false : _ref$verbose,
          _ref$values = _ref.values,
          values = _ref$values === void 0 ? {} : _ref$values,
          _ref$strict = _ref.strict,
          strict = _ref$strict === void 0 ? true : _ref$strict,
          _ref$field = _ref.field,
          field = _ref$field === void 0 ? "" : _ref$field;

      for (var i = 0; i < _classPrivateFieldGet(this, _rules).length; i += 1) {
        var _classPrivateFieldGet2 = _classPrivateFieldGet(this, _rules)[i],
            name = _classPrivateFieldGet2.name,
            rule = _classPrivateFieldGet2.rule,
            args = _classPrivateFieldGet2.args,
            _not3 = _classPrivateFieldGet2.not,
            _classPrivateFieldGet3 = _classPrivateFieldGet2.options,
            constraint = _classPrivateFieldGet3.constraint,
            message = _classPrivateFieldGet3.message;

        var isRuleSuccess = _not3 !== rule.apply(void 0, _toConsumableArray(resolveArgs(args, values)).concat([value]));

        var isOptionalRule = name === "required" && (_not3 || strict && constraint && !constraint.validate(values));

        if (isOptionalRule) {
          if (isOptionalSuccess(value, _classPrivateFieldGet(this, _rules)[i + 1].name)) {
            break;
          }
        } else if (!isRuleSuccess && !constraint || name === "required" && !_not3 && strict && constraint && !isRuleSuccess || isFail(isRuleSuccess, constraint, strict, values)) {
          return verbose === true ? messageTemplate(message, value, field) : false;
        }
      }

      return true;
    }
  }, {
    key: "not",
    get: function get() {
      return new Field(_toConsumableArray(_classPrivateFieldGet(this, _rules)), true);
    }
  }]);

  return Field;
}();

var _rules = new WeakMap();

var _not = new WeakMap();

var FieldObject = rulesWrapper(allRules)(Field);

var validation = function validation(schema, values, options) {
  var rules = Object.entries(schema);

  for (var i = 0; i < rules.length; i += 1) {
    var _rules$i = _slicedToArray(rules[i], 2),
        name = _rules$i[0],
        rule = _rules$i[1];

    if (!rule.validate(values[name], _objectSpread({
      values: values
    }, options))) {
      return false;
    }
  }

  return true;
};

var verboseValidation = function verboseValidation(schema, values, bool, options) {
  var errors = null;
  Object.entries(schema).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        rule = _ref2[1];

    var result = rule.validate(values[name], _objectSpread({
      verbose: rule instanceof Field ? !bool : true,
      field: name,
      bool: bool,
      values: values
    }, options, {
      async: false
    }));

    if (result !== true && result !== null || bool) {
      errors = _objectSpread({}, errors, _defineProperty({}, name, result));
    }
  });
  return errors;
};

var SchemaObject = function SchemaObject(rules) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    verbose: false,
    strict: true,
    bool: false,
    async: false
  };

  function Schema() {}

  Object.entries(rules).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        name = _ref4[0],
        rule = _ref4[1];

    Schema.prototype[name] = rule;
  });

  Schema.prototype.validate = function () {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref5$verbose = _ref5.verbose,
        verbose = _ref5$verbose === void 0 ? options.verbose : _ref5$verbose,
        _ref5$strict = _ref5.strict,
        strict = _ref5$strict === void 0 ? options.strict : _ref5$strict,
        _ref5$bool = _ref5.bool,
        bool = _ref5$bool === void 0 ? options.bool : _ref5$bool,
        _ref5$async = _ref5.async,
        async = _ref5$async === void 0 ? options.async : _ref5$async;

    if (async) {
      return new Promise(function (resolve, reject) {
        if (verbose) {
          var result = verboseValidation(rules, values, bool, {
            strict: strict
          });

          if (bool) {
            if (hasFalse(result)) {
              reject(result);
            } else {
              resolve(values);
            }
          } else if (result === null) {
            resolve(values);
          }

          reject(result);
        } else if (validation(rules, values, {
          strict: strict
        }) === true) {
          resolve(values);
        } else {
          reject();
        }
      });
    }

    if (verbose) {
      return verboseValidation(rules, values, bool, {
        strict: strict
      });
    }

    return validation(rules, values, {
      strict: strict
    });
  };

  return new Schema();
};

var validation$1 = function validation(name, rule, values) {
  if (!isArray(name)) {
    return rule.validate(getValue(name.slice(1), values), {
      values: values
    });
  }

  for (var i = 0; i < name.length; i += 1) {
    if (!rule.validate(getValue(name[i].slice(1), values), {
      values: values
    })) {
      return false;
    }
  }

  return true;
};

var When =
/*#__PURE__*/
function () {
  function When(_rules2) {
    _classCallCheck(this, When);

    _rules$1.set(this, {
      writable: true,
      value: null
    });

    _classPrivateFieldSet(this, _rules$1, _rules2);
  }

  _createClass(When, [{
    key: "end",
    value: function end(name, rule) {
      return new When([].concat(_toConsumableArray(_classPrivateFieldGet(this, _rules$1)), ["&&", {
        name: name,
        rule: rule
      }]));
    }
  }, {
    key: "or",
    value: function or(name, rule) {
      return new When([].concat(_toConsumableArray(_classPrivateFieldGet(this, _rules$1)), ["||", {
        name: name,
        rule: rule
      }]));
    }
  }, {
    key: "validate",
    value: function validate(values) {
      var result = [];

      _classPrivateFieldGet(this, _rules$1).forEach(function (rule) {
        if (isObject(rule)) {
          result = [].concat(_toConsumableArray(result), [validation$1(rule.name, rule.rule, values)]);
        } else {
          result = [].concat(_toConsumableArray(result), [rule]);
        }
      });

      return execute(result);
    }
  }]);

  return When;
}();

var _rules$1 = new WeakMap();

var Field$1 = function Field$$1() {
  return new FieldObject();
};

var When$1 = function When$$1(name, rule) {
  return new When([{
    name: name,
    rule: rule
  }]);
};

var Schema = SchemaObject;
export { Field$1 as Field, When$1 as When, Schema };